import { useLazyQuery, useMutation } from "@apollo/client/react";
import AttachFileIcon from '@mui/icons-material/AttachFile';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import { FormControl, Grid, InputAdornment, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import moment from 'moment';
import 'moment/locale/es';
import { useEffect, useMemo, useRef, useState } from 'react';
import toast from 'react-hot-toast';
import { adaptDelegacionTodosArray } from '../../../adapters/delegacionAdapter';
import DocumentViewer from '../../../components/DocumentViewer';
import { CustomChip } from '../../../components/chip/Chip';
import { CustomButton } from '../../../components/customButton/CustomButton';
import { CustomDialog } from '../../../components/customDialog/CustomDialog';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import { DateInput } from '../../../components/dateInput/DateInput';
import { SelectInput } from '../../../components/selectInput/SelectInput';
import { TextInput } from '../../../components/textInput/TextInput';
import { ADD_MASSIVE_INSTANCIA_CREDITICIA } from '../../../data/graphQL/mutations/GestionCrediticia/AddMassiveInstanciaCrediticia';
import { GET_DOCUMENTO_CREDITICIA } from '../../../data/graphQL/queries/GestionCrediticia/getDocumentoCrediticia';
import { GET_ESTADOS_CREDITICIO } from '../../../data/graphQL/queries/GestionCrediticia/getEstadosCrediticio';
import { GET_MOTIVO_CREDITICA } from '../../../data/graphQL/queries/GestionCrediticia/getMotivoCrediticia';
import { GET_SOLICITUD_CREDITICIA } from '../../../data/graphQL/queries/GestionCrediticia/getSolicitudCrediticia';
import { GET_SOLICITUDES_GESTION_CRED } from '../../../data/graphQL/queries/GestionCrediticia/getSolicitudesGestionCrediticia';
import { GET_DELEGACIONES_BY_USUARIO } from '../../../data/graphQL/queries/PacienteProbable/getAllDelegacionesByUsuario';
import { GET_USUARIO_DELEGACION_ORIGEN } from '../../../data/graphQL/queries/usuarios/getUsuarioDelegacionOrigen';
import { getDateNow, getDateToString } from '../../../utils/convert';
import { CompareDates } from '../../../utils/helpers';
import './gestionCrediticiaContent.scss';
import { VALIDATE_CONTRATO } from '../../../data/graphQL/mutations/Contratos/validateContrato';

const locale = "es-ES";

export const GestionCrediticiaContent = ({ setChildrenAction }) => {
  const [evaluacionesSelected, setEvaluacionesSelected] = useState([]);
  const [openGestion, setOpenGestion] = useState(false);
  const [openGestionInfo, setOpenGestionInfo] = useState(false);
  const [estadoSelected, setEstadoSelected] = useState();
  const [motivoSelected, setMotivoSelected] = useState();
  const [observaciones, setObservaciones] = useState('');
  const [estados, setEstados] = useState([]);
  const [motivos, setMotivos] = useState([]);
  const [loadingGrabar, setLoadingGrabar] = useState(false);
  const [delegaciones, setDelegaciones] = useState([]);
  const [delegacionOrigen, setDelegacionOrigen] = useState(0);
  const [showGestionar, setShowGestionar] = useState(true);
  const [filePreview, setFilePreview] = useState(null);
  const [openPreview, setOpenPreview] = useState(false);

  // Estados
  const ESTADO_PE = "Pendiente";
  const ESTADO_RE = "Rechazado";
  const ESTADO_SA = "Satisfactorio";
  const ESTADO_BT = "Bloqueo Temporal";
  const DELEGACION_TODAS = 1;

  const [solicitudes, setSolicitudes] = useState([]);
  const [datosOriginal, setDatosOriginal] = useState('');
  const [rowSelectionModel, setRowSelectionModel] = useState([]);

  const initialSolicitudInfo = {
    evaluacion: '',
    paciente: '',
    cliente: '',
    gestionadoPor: '',
    fechaHora: '',
    estado: '',
    motivo: '',
    observaciones: ''
  };

  const initialFilters = {
    idDelegacion: delegacionOrigen,
    fechaDesde: null,
    fechaHasta: null,
    idEstadoCrediticio: "2" // pendiente
  };
  const [filtros, setFiltros] = useState(initialFilters);
  const [solicitudInfo, setSolicitudInfo] = useState(initialSolicitudInfo);
  const txtFiltro = useRef(null);

  const handleSelectionModelChange = (ids) => {
    setRowSelectionModel(ids);
    if (ids.length > 0) {
      setEvaluacionesSelected(solicitudes.map((row, index) => {
        if (ids.includes(index + 1))
          return row.idEvaluacion;
      }));
    } else
      setEvaluacionesSelected([]);

    if (filtros?.idEstadoCrediticio == "3") {
      let noGestionar = false;
      if (ids.length > 0) {
        solicitudes.map((row, index) => {
          if (ids.includes(index + 1)) {
            if (CompareDates(new Date(moment(row?.fechaEstadoCrediticio)).setHours(0, 0, 0, 0), getDateNow(false)) !== 0) {
              noGestionar = true;
            }
          }
        });
      }
      setShowGestionar(!noGestionar);
    }
  };

  const handleRowClick = (params) => {
    let idEvaluacion = params.row?.idEvaluacion;

    getSolicitudCrediticiaById({ variables: { idEvaluacion: idEvaluacion } });
    setSolicitudInfo((previousData) => ({
      ...previousData,
      cliente: params.row?.razonSocial
    }));

  };

  const handleCloseGestion = () => {
    setOpenGestion(false);
    handleCleanGestion();
  };

  const handleCloseGestionInfo = () => {
    setOpenGestionInfo(false);
  };

  const handleCleanGestion = () => {
    setObservaciones('');
    setMotivoSelected(0);
    setEstadoSelected(0);
    setLoadingGrabar(false);
  };

  const validClickAgregar = () => {
    let evaluaciones = evaluacionesSelected.filter((n) => n != null);

    if (estadoSelected == 0) {
      toast.error("Debe ingresar un estado");
      return false;
    }
    if (estadoSelected == 1) {
      if (solicitudes.filter((x) => evaluaciones.includes(x.idEvaluacion)).map((x) => x.bloqueoSAP).includes(true)) {
        toast.error("Una de las evaluaciones seleccionadas tiene un bloqueo en SAP.");
        return false;
      }
    }
    if (estadoSelected == 3 || estadoSelected == 4) {
      if (!motivoSelected) {
        toast.error("Debe ingresar un motivo");
        return false;
      }
      if (observaciones == "") {
        toast.error("Debe ingresar una observación");
        return false;
      }
    }

    return true;
  };

  const handleClickAgregar = () => {
    if (validClickAgregar()) {
      setLoadingGrabar(true);
      addMassiveInstanciaCrediticia({
        variables: {
          idEstado: estadoSelected,
          idEvaluaciones: evaluacionesSelected.filter((n) => n != null),
          idMotivo: motivoSelected != 0 ? motivoSelected : null,
          motivo: observaciones
        }
      });
    }
  };

  const handlePreview = (row) => {
    getDocumento({ variables: { IdEvaluacion: row.idEvaluacion } });
  };

  const initialColumns = [
    {
      field: 'idDelegacion',
      width: 150,
      headerName: 'Delegación',
      valueGetter: (idDelegacion) => {
        return delegaciones?.find((tp) => tp.id == idDelegacion)?.displayName;
      }
    },
    {
      field: 'idEvaluacion',
      width: 80,
      headerName: 'Contrato'
    },
    {
      field: 'tipo',
      width: 60,
      headerName: 'Origen',
      align: 'center'
    },
    {
      field: 'paciente',
      width: 200,
      headerName: 'Paciente',
      valueGetter: (_, row) => {
        return row?.apellido + ', ' + row?.nombre;
      }
    },
    {
      field: 'idCliente',
      width: 100,
      headerName: 'Cod. Cliente'
    },
    {
      field: 'cUIT',
      width: 100,
      headerName: 'CUIT'
    },
    {
      field: 'razonSocial',
      width: 250,
      headerName: 'Cliente'
    },
    {
      field: 'bloqueoSAP',
      width: 70,
      type: 'boolean',
      headerName: 'B. SAP'
    },
    {
      field: 'usuario',
      width: 190,
      headerName: 'Usuario'
    },
    {
      field: 'fechaNotificacionCrediticia',
      width: 120,
      headerName: 'F. Notificación',
      valueGetter: (fechaNotificacionCrediticia) => {
        return fechaNotificacionCrediticia ? moment(fechaNotificacionCrediticia).format('DD/MM/yyyy') : '';
      }
    },
    {
      field: 'estadoCrediticia',
      width: 200,
      headerName: 'Estado',
      headerAlign: 'center',
      align: 'center',
      renderCell: ({ row }) => {

        const getChipColor = (estadoCreditica) => {
          const estados = {
            1: { isGreen: true },
            2: { isYellow: true },
            3: { isRed: true },
            4: { isBlack: true }
          };

          return estados[estadoCreditica];
        };

        return (
          <CustomChip
            label={estados?.find((r) => r.id == row?.idEstadoCrediticio)?.displayName ?? 'Pendiente'}
            {...getChipColor(row?.idEstadoCrediticio > 0 ? row?.idEstadoCrediticio : 2)} />);



      }
    },
    {
      width: 80,
      headerName: 'Adjunto',
      headerAlign: 'center',
      align: 'center',
      renderCell: (cellProps) => {
        const { row } = cellProps;
        return (
          row.tieneAdjunto &&
          <AttachFileIcon className='edit-icon' onClick={() => handlePreview(row)} />);

      }
    }];


  const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns, true), [delegaciones, estados, filtros?.idEstadoCrediticio]);

  const storageId = sessionStorage.getItem('idUsuario');
  const [getDelegaciones, { data: dataDelegaciones, loading: delegacionesLoading }] = useLazyQuery(GET_DELEGACIONES_BY_USUARIO, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataDelegaciones) return;
    setDelegaciones(adaptDelegacionTodosArray(dataDelegaciones));
  }, [dataDelegaciones]);

  const actualizarEstadoEvaluaciones = () => {
    if (estadoSelected == 3) {
      const idEvaluaciones = [...evaluacionesSelected.filter((n) => n != null)];
      idEvaluaciones.forEach(idEv => {
        validateContrato({
          variables: { idEvaluacion: idEv }
        });
      });
    }
  };

  const [validateContrato] = useMutation(VALIDATE_CONTRATO);

  const [addMassiveInstanciaCrediticia] = useMutation(ADD_MASSIVE_INSTANCIA_CREDITICIA, {
    onCompleted: (data) => {
      setOpenGestion(false);
      handleCleanGestion();
      if (data.addMassiveInstanciaCrediticia.success) {
        toast.success("Gestión crediticia grabada correctamente.");

        actualizarEstadoEvaluaciones();

        setLoadingGrabar(false);
        setEvaluacionesSelected([]);
        setSolicitudes([]);
        setDatosOriginal([]);

        setTimeout(() => {
          getSolicitudes({ variables: { filter: filtros } });
        }, 500);
      } else {
        toast.error("Se produjo un error al intentar procesar la solicitud");
      }
    },
    refetchQueries: [GET_SOLICITUDES_GESTION_CRED]
  });

  const [getSolicitudCrediticiaById, { data: dataSolicitudCrediticia, loading: solicitudLoading }] = useLazyQuery(GET_SOLICITUD_CREDITICIA, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataSolicitudCrediticia) return;
    setOpenGestionInfo(true);
    let apellidoGestionadoPor = dataSolicitudCrediticia?.solicitudCrediticiaByEvaluacion?.idUsuarioAutorizadorNavigation?.apellido ?
      dataSolicitudCrediticia?.solicitudCrediticiaByEvaluacion?.idUsuarioAutorizadorNavigation?.apellido : '';
    let nombreGestionadoPor = dataSolicitudCrediticia?.solicitudCrediticiaByEvaluacion?.idUsuarioAutorizadorNavigation?.nombre ?
      dataSolicitudCrediticia?.solicitudCrediticiaByEvaluacion?.idUsuarioAutorizadorNavigation?.nombre : '';

    setSolicitudInfo((previousData) => ({
      ...previousData,
      evaluacion: dataSolicitudCrediticia?.solicitudCrediticiaByEvaluacion?.idEvaluacion,
      paciente: dataSolicitudCrediticia?.solicitudCrediticiaByEvaluacion?.idPacienteNavigation?.apellido + ' ' + dataSolicitudCrediticia?.solicitudCrediticiaByEvaluacion?.idPacienteNavigation?.nombre,
      gestionadoPor: apellidoGestionadoPor + ' ' + nombreGestionadoPor,
      fechaHora: dataSolicitudCrediticia?.solicitudCrediticiaByEvaluacion?.fechaEstadoCrediticio,
      estado: dataSolicitudCrediticia?.solicitudCrediticiaByEvaluacion?.idEstadoCrediticioNavigation?.descripcion,
      motivo: dataSolicitudCrediticia?.solicitudCrediticiaByEvaluacion?.idMotivoCrediticioNavigation?.motivoBloqueo,
      observaciones: dataSolicitudCrediticia?.solicitudCrediticiaByEvaluacion?.observacionCrediticia
    }));
  }, [dataSolicitudCrediticia]);

  const [getEstados, { data: dataEstados, loading: estadosLoading }] = useLazyQuery(GET_ESTADOS_CREDITICIO);

  useEffect(() => {
    if (!dataEstados) return;
    setEstados(dataEstados.allEstadoCrediticio?.map((estado) => { return { id: estado.idEstadoCrediticio, displayName: estado.descripcion }; }));
  }, [dataEstados]);

  const [getMotivos, { data: dataMotivos, loading: motivosLoading }] = useLazyQuery(GET_MOTIVO_CREDITICA);

  useEffect(() => {
    if (!dataMotivos) return;
    setMotivos(dataMotivos.allMotivosCrediticia?.map((motivo) => { return { id: motivo.idMotivoResolucionCrediticia, displayName: motivo.motivoBloqueo }; }));
  }, [dataMotivos]);

  const [getDocumento, { data: dataDocumento }] = useLazyQuery(GET_DOCUMENTO_CREDITICIA);

  useEffect(() => {
    if (!dataDocumento) return;
    setFilePreview(dataDocumento?.documentByEvaluacionId);
    setOpenPreview(true);
  }, [dataDocumento]);

  const [getDelegacionOrigen, { data: dataDelegacionOrigen }] = useLazyQuery(GET_USUARIO_DELEGACION_ORIGEN, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataDelegacionOrigen) return;
    if (dataDelegacionOrigen.usuarioFull.success) {
      const deleg = parseInt(dataDelegacionOrigen.usuarioFull.valorEsperado.delegacionOrigen, 10);
      sessionStorage.setItem('delegacionOrigen', deleg);
      setDelegacionOrigen(deleg);

      setFiltros((previousData) => ({
        ...previousData,
        idDelegacion: !delegaciones.some((x) => x.id === 1) ? deleg : DELEGACION_TODAS
      }));
    }
  }, [dataDelegacionOrigen]);

  useEffect(() => {
    setChildrenAction(() => <>

      {evaluacionesSelected.length > 0 && showGestionar && filtros.idEstadoCrediticio != "1" &&
        <CustomButton
          onClick={() => setOpenGestion(true)}>

          Gestionar
        </CustomButton>}
    </>
    );
  }, [setChildrenAction, evaluacionesSelected, filtros]);

  useEffect(() => {
    if (!estadosLoading) {
      getEstados();
    }
    if (!motivosLoading) {
      getMotivos();
    }
    if (!delegacionesLoading) {
      getDelegaciones({ variables: { idUsuario: JSON.parse(storageId, 10) } });
    }
    getDelegacionOrigen({ variables: { idUsuario: JSON.parse(storageId, 10) } });
  }, []);

  useEffect(() => {
    if (!solicitudesLoading && delegacionOrigen > 0) {
      getSolicitudes({ variables: { filter: filtros } });
    }
  }, [delegacionOrigen]);

  const [getSolicitudes, { data: dataSolicitudes, loading: solicitudesLoading }] = useLazyQuery(GET_SOLICITUDES_GESTION_CRED, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataSolicitudes) return;
    setSolicitudes(dataSolicitudes.solicitudesGestionCrediticia.valorEsperado);
    setDatosOriginal(dataSolicitudes.solicitudesGestionCrediticia.valorEsperado);
  }, [dataSolicitudes]);

  const handleTextFilter = () => {
    // si se ingresó texto a buscar (al menos 2 caracteres) --> filtro, sino retorno todos los registros
    // originales consultados
    if (txtFiltro.current.value != "") {
      if (txtFiltro.current.value.length >= 2) {
        setSolicitudes(datosOriginal.filter((datosOriginal) => {
          const contratoBuscar = datosOriginal.idEvaluacion.toString().toUpperCase();
          const tipoBuscar = datosOriginal.tipo ? datosOriginal?.tipo?.toString().toUpperCase() : '';
          const nombrePacienteBuscar = `${datosOriginal.apellido}, ${datosOriginal.nombre}`.toUpperCase();
          const clienteBuscar = datosOriginal.razonSocial.toUpperCase();
          const cuitBuscar = datosOriginal.cUIT ? datosOriginal.cUIT.toString() : '';
          const codigoClienteBuscar = datosOriginal.idCliente ? datosOriginal.idCliente.toString().toUpperCase() : '';

          const inputBuscar = txtFiltro.current.value.toUpperCase();
          return (
            contratoBuscar.includes(inputBuscar) ||
            tipoBuscar.includes(inputBuscar) ||
            nombrePacienteBuscar.includes(inputBuscar) ||
            clienteBuscar.includes(inputBuscar) ||
            cuitBuscar.includes(inputBuscar) ||
            codigoClienteBuscar.includes(inputBuscar));

        }
        ));
      }
    } else {
      setSolicitudes(datosOriginal);
    }
  };

  const handleTextClean = () => {
    txtFiltro.current.value = "";
    handleTextFilter();
    txtFiltro.current.focus();
  };

  const handleChangeEstado = (value) => {
    let idEstadoCrediticio = value.target.value;

    setFiltros((previousData) => ({
      ...previousData,
      fechaDesde: idEstadoCrediticio != "2" && idEstadoCrediticio != "4" ? moment().add(-30, 'd').format("yyyy-MM-DD") : null,
      fechaHasta: idEstadoCrediticio != "2" && idEstadoCrediticio != "4" ? moment().format("yyyy-MM-DD") : null,
      idEstadoCrediticio: idEstadoCrediticio
    }));

    setSolicitudes([]);
    setDatosOriginal([]);
  };

  const handleChangeFechaDesde = (value) => {
    const nuevaFecha = value ? moment(value).format("yyyy-MM-DD") : null;
    setFiltros((previousData) => ({
      ...previousData,
      fechaDesde: nuevaFecha
    }));
  };

  const handleChangeFechaHasta = (value) => {
    const nuevaFecha = value ? moment(value).format("yyyy-MM-DD") : null;
    setFiltros((previousData) => ({
      ...previousData,
      fechaHasta: nuevaFecha
    }));
  };

  const handleChange = (e) => {
    const { value, name } = e.target;
    setFiltros((previousData) => ({
      ...previousData,
      [name]: value
    }));
  };

  const filtrosValidos = () => {
    if (filtros.idEstadoCrediticio == "1") {
      if (filtros.fechaDesde == "") {
        toast.error("La Fecha Desde es obligatoria.");
        return false;
      }
      if (filtros.fechaHasta == "") {
        toast.error("La Fecha Hasta es obligatoria.");
        return false;
      }
      if (filtros.fechaHasta < filtros.fechaDesde) {
        toast.error("La Fecha Hasta no puede ser anterior a la Fecha Desde.");
        return false;
      }
    }

    return true;
  };

  const handleSearch = () => {
    if (!solicitudesLoading && filtrosValidos()) {
      getSolicitudes({ variables: { filter: filtros } });
    }
  };

  const getChipEstado = (estado) => {
    switch (estado) {
      case ESTADO_PE:
        return (
          <CustomChip label={estado} isYellow />);
      case ESTADO_SA:
        return (
          <CustomChip label={estado} isGreen />);
      case ESTADO_RE:
        return (
          <CustomChip label={estado} isRed />);
      case ESTADO_BT:
        return (
          <CustomChip label={estado} isBlack />);
      default:
        return null;
    }
  };

  return (
    <>

      <CustomDialog
        open={openGestion}
        onClose={handleCloseGestion}
        maxWidth='md'
        fullWidth={true}
        title={'Gestionar'}
        acceptLoading={loadingGrabar}
        onCancel={handleCloseGestion}
        onAccept={handleClickAgregar}
        acceptText='Aplicar'>

        <div className="dialog-content">
          <Grid
            container
            justifyContent={'space-between'}
            rowGap={1}
            spacing={1.5}
            columns={{
              xs: 2,
              md: 4
            }}>

            <Grid size={{ xs: 2 }}>
              <SelectInput
                options={estados}
                label='Estado'
                onChange={(e) => {
                  const estado = e.target.value;
                  setEstadoSelected(estado);
                  if (estado != 3 && estado != 4) setMotivoSelected(null);
                }}
                value={estadoSelected} />

            </Grid>
            <Grid size={{ xs: 2 }}>
              {(estadoSelected === 3 || estadoSelected === 4) &&
                <SelectInput
                  options={motivos}
                  label='Motivo'
                  onChange={(e) => { setMotivoSelected(e.target.value); }}
                  value={motivoSelected} />
              }
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextInput
                label='Observaciones'
                placeholder='Ingrese Observaciones'
                name='observacion'
                value={observaciones}
                onChange={(e) => setObservaciones(e.target.value)}
                multiline={true}
                rows={4} />

            </Grid>
          </Grid>
        </div>
      </CustomDialog>
      <CustomDialog
        open={openGestionInfo}
        onClose={handleCloseGestionInfo}
        maxWidth='md'
        fullWidth={true}
        title={'#' + solicitudInfo.evaluacion + ' - ' + solicitudInfo.paciente + ' - ' + solicitudInfo.cliente}
        onCancel={handleCloseGestionInfo}
        cancelText='Cerrar'>

        <div className="dialog-content">
          <Grid
            container
            justifyContent={'space-between'}
            columns={{
              xs: 2,
              md: 4
            }}
            rowGap={2}>

            <Grid size={{ md: 1 }}>
              <strong>Gestionado por</strong>
              <br />
              <label>{solicitudInfo.gestionadoPor}</label>
            </Grid>
            <Grid size={{ md: 1 }}>
              <strong>Fecha y hora</strong>
              <br />
              <label>{getDateToString(solicitudInfo.fechaHora, true)}</label>
            </Grid>
            <Grid size={{ md: 1 }}>
              <strong>Estado</strong>
              <br />
              {getChipEstado(solicitudInfo.estado)}
            </Grid>
            <Grid size={{ md: 1 }}>
              <strong>Motivo</strong>
              <br />
              <label>{solicitudInfo.motivo}</label>
            </Grid>

            <Grid size={{ md: 4 }}>
              <strong>Observaciones</strong>
              <br />
              <label>{solicitudInfo.observaciones}</label>
            </Grid>

          </Grid>
        </div>
      </CustomDialog>
      <div className='grid-container'>
        <Grid
          container
          spacing={2}
          sx={{ marginBottom: '25px' }}>

          <Grid size={{ md: 2.5 }}>
            <FormControl sx={{ backgroundColor: 'white', width: '100%' }} size="small">
              <InputLabel id="select-delegacion">Delegación</InputLabel>
              <Select
                labelId="select-delegacion"
                options={delegaciones}
                label='Delegación'
                onChange={handleChange}
                value={filtros?.idDelegacion}
                name='idDelegacion'>

                {delegaciones && delegaciones.map((delegacion) => {
                  return <MenuItem key={delegacion.id} value={delegacion.id}> {delegacion.displayName} </MenuItem>;
                })}
              </Select>
            </FormControl>
          </Grid>
          <Grid size={{ md: 2.7 }}>
            <TextField
              label="Filtrar"
              name="txtFiltro"
              size="small"
              type="text"
              variant="outlined"
              inputRef={txtFiltro}
              onKeyUp={handleTextFilter}
              sx={{ backgroundColor: 'white' }}
              InputProps={{
                endAdornment:
                  <InputAdornment position="end">
                    <SearchIcon
                      onClick={handleTextFilter}
                      sx={{ cursor: 'pointer' }} />

                    <ClearIcon
                      onClick={handleTextClean}
                      sx={{ cursor: 'pointer' }} />

                  </InputAdornment>

              }} />

          </Grid>
          <Grid size={{ md: 2 }}>
            <FormControl sx={{ backgroundColor: 'white', width: '100%' }} size="small">
              <InputLabel id="select-idEstadoCrediticio">Estado</InputLabel>
              <Select
                labelId="select-idEstadoCrediticio"
                label='idEstadoCrediticio'
                onChange={handleChangeEstado}
                value={filtros?.idEstadoCrediticio}
                name='idEstadoCrediticio'>

                <MenuItem value="2">Pendiente</MenuItem>
                <MenuItem value="1">Satisfactorio</MenuItem>
                <MenuItem value="3">Rechazado</MenuItem>
                <MenuItem value="4">Bloqueado Temporalmente</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid size={{ md: 1.8 }}>
            <DateInput
              label="Fecha Desde"
              value={filtros.fechaDesde}
              onChange={handleChangeFechaDesde} />

          </Grid>
          <Grid size={{ md: 1.8 }}>
            <DateInput
              label="Fecha Hasta"
              value={filtros.fechaHasta}
              onChange={handleChangeFechaHasta} />

          </Grid>
          <Grid sx={{ textAlign: 'right' }} size={{ md: 1.2 }}>
            <CustomButton
              variant='contained'
              className='margin-right'
              onClick={handleSearch}
              size='small'>

              Buscar
            </CustomButton>
          </Grid>
        </Grid>
        <DataGridGenerico
          columns={columns}
          maxWidth={columns.reduce((total, column) => total + (column.width || 0), 0)}
          rows={solicitudes}
          toolbar={false}
          loading={solicitudesLoading}
          checkboxSelection={filtros?.idEstadoCrediticio != "1"}
          onRowSelectionModelChange={handleSelectionModelChange}
          rowSelectionModel={rowSelectionModel}
          onRowClick={filtros?.idEstadoCrediticio != "2" && filtros?.idEstadoCrediticio != "4" ? handleRowClick : null} />

        {openPreview && <DocumentViewer data={filePreview} setOpenDlg={setOpenPreview} download={true} />}

      </div>
    </>);

};